import { Injectable } from '@angular/core';

import { AuthService } from "../../../shared/services/auth.service";
import { newRoute, editRoute } from "../../../shared/services/data.service";
import { despachosRoute } from "../../shared/data.service";
import { segurosRoute } from "./data.service";

@Injectable()
export class SeguroNavigationService {

  constructor(
    private _authService: AuthService
  ) { }

  goToList() {
    var router: string = despachosRoute + '/' + segurosRoute;
    this._authService.navigateTo(router);
  }

  goToNew() {
    var router: string = despachosRoute + '/' + segurosRoute + '/' + newRoute;
    this._authService.navigateTo(router);
  }

  goToEdit(objectId: number) {
    var router: string = despachosRoute + '/' + segurosRoute + '/' + editRoute;
    this._authService.navigateTo(router, objectId);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguros/shared/seguro-navigation.service.ts
 **/